window.addEventListener('DOMContentLoaded', function() {
  const enableCounterAnimations = function() {
    class CountUp {
      constructor(target, startVal, endVal, decimals, duration, options) {
        this.options = options || {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          easingFn: null,
          formattingFn: null
        };

        this.d = target;
        this.startVal = Number(startVal);
        this.endVal = Number(endVal);
        this.countDown = this.startVal > this.endVal;
        this.startTime = null;
        this.timestamp = null;
        this.remaining = null;
        this.frameVal = this.startVal;
        this.rAF = null;
        this.decimals = Math.max(0, decimals || 0);
        this.dec = Math.pow(10, this.decimals);
        // make the duration a random number between duration - 50% and duration + 50%
        // this is done to have a slight variation in the duration of each animation;
        const randomDuration = duration * (Math.random() * (1.5 - 0.5) + 0.5); 
        this.duration = Number(randomDuration) * 1000 || 2000;
        this.version = '1.9.3';
        this.printValue = this.formatNumber(this.startVal);
        
        if (isNaN(this.startVal) || isNaN(this.endVal) || isNaN(this.decimals) || isNaN(this.duration)) {
          this.error = true;
          console.error('One or more of the input values is not a number.');
        } else if (this.startVal === this.endVal) {
          this.error = true;
          console.error('Start value and end value cannot be the same.');
        } else {
          this.error = false;
          this.d.innerHTML = '<span class="hc-counter">' + this.printValue + '</span>';
        }
      }
      formatNumber(num) {
        num = num.toFixed(this.decimals);
        num += '';
        const x = num.split('.');
        let x1 = x[0];
        const x2 = x.length > 1 ? this.options.decimal + x[1] : '';
        const rgx = /(\d+)(\d{3})/;
        if (this.options.useGrouping) {
          while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + this.options.separator + '$2');
          }
        }
        let out = x1 + x2;
        return out;
      }
      start(callback) {
        if (this.error) {
          return;
        }
        this.callback = callback;
        if (this.duration > 0) {
          this.d.style.animationDuration = this.duration + 'ms';
        }
        requestAnimationFrame(timestamp => {
          this.startTime = timestamp;
          this.animate(timestamp);
        });
      }
      animate(timestamp) {
        if (this.error) {
          return;
        }
        this.timestamp = timestamp;
        const progress = timestamp - this.startTime;
        this.remaining = this.duration - progress;
        if (this.options.useEasing) {
          if (this.countDown) {
            this.frameVal = this.startVal - this.easingFn(progress, 0, this.startVal - this.endVal, this.duration);
          } else {
            this.frameVal = this.easingFn(progress, this.startVal, this.endVal - this.startVal, this.duration);
          }
        } else {
          if (this.countDown) {
            this.frameVal = this.startVal - ((this.startVal - this.endVal) * (progress / this.duration));
          } else {
            this.frameVal = this.startVal + (this.endVal - this.startVal) * (progress / this.duration);
          }
        }
        if (this.countDown) {
          this.frameVal = this.frameVal < this.endVal ? this.endVal : this.frameVal;
        } else {
          this.frameVal = this.frameVal > this.endVal ? this.endVal : this.frameVal;
        }
        this.frameVal = Math.round(this.frameVal * this.dec) / this.dec;
        this.printValue = this.formatNumber(this.frameVal);
        this.d.innerHTML = '<span class="hc-counter">' + this.printValue + '</span>';
        if (progress < this.duration) {
          this.rAF = requestAnimationFrame(this.animate.bind(this));
        } else {
          if (this.callback) {
            this.callback();
          }
        }
      }
      easingFn(t, b, c, d) {
        // easeOut 
        return c * (t / d) * (2 - t / d) + b;
      }
    }
    const detectAndEnableCounter = function(counterContainer) {
      // Find any number inside the container, even with a comma as thousand separator as a single string
      const numberString = counterContainer.innerText.match(/(\d+,?)+/)?.[0];
      if (!numberString) return;
      const number = parseFloat(numberString.replace(',', ''));

      let counterElement = document.createElement('span');
      counterElement.classList.add('hc-counter');
      // we deep search the text nodes in counterContainer and its children and replace the number string with the counter element
      const searchTextNodesOfElement = function(element) {
        const childNodes = element.childNodes;
        for (const childNode of childNodes) {
          if (childNode.nodeType === Node.TEXT_NODE) {
            const text = childNode.textContent;
            if (text.includes(numberString)) {
              const textParts = text.split(numberString);
              const textNodes = [];
              for (let i = 0; i < textParts.length; i++) {
                textNodes.push(document.createTextNode(textParts[i]));
                if (i < textParts.length - 1) {
                  textNodes.push(counterElement);
                }
              }
              childNode.replaceWith(...textNodes);
            }
          } else {
            searchTextNodesOfElement(childNode);
          }
        }
      };
      searchTextNodesOfElement(counterContainer);
      // counterContainer.innerHTML = counterContainer.innerHTML.replace(numberString, counterElement.outerHTML);
      // counterElement = counterContainer.querySelector('.hc-counter');
      const counter = new CountUp(counterElement, 0, number, 0, 2);
      
      if (!counter.error) {
        // animate the counter when it's visible in the viewport
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              counter.start();
              observer.unobserve(counterContainer);
            }
          });
        });
        observer.observe(counterContainer);
      }
    };
    const counterContainers = document.querySelectorAll('.hc-enable-counter-animation');
    counterContainers.forEach(detectAndEnableCounter);
  }

  enableCounterAnimations();

});